export const SHOW_SAVED_ROOQUESTS = 'SHOW_SAVED_ROOQUESTS';
export const UNSHOW_SAVED_ROOQUESTS = 'UNSHOW_SAVED_ROOQUESTS';

export const SHOW_MAP_MODE_FEED = 'SHOW_MAP_MODE_FEED';
export const UNSHOW_MAP_MODE_FEED = 'UNSHOW_MAP_MODE_FEED';

export const SET_ROOQUEST_SEARCH_RADIUS = 'SET_ROOQUEST_SEARCH_RADIUS';

export const SET_DELIVER_NOW_FILTERS = 'SET_DELIVER_NOW_FILTERS'
